import { Stack } from "@mui/material";

import { DialogFooter } from "../../../components/DialogFooter";
import { IconButton } from "../../../components/IconButton";
import { LoadingButton } from "../../../components/LoadingButton";
import { TextButton } from "../../../components/TextButton";

interface FiltersBottomSheetFooterProps {
  showClearFormButton: boolean;
  showCloseButton?: boolean;
  openShiftsCount: number;
  openShiftsIsLoading: boolean;
  withShadow?: boolean;
  onClear: () => void;
  onSubmit: () => void;
  onCancel: () => void;
}

export function FiltersBottomSheetFooter(props: FiltersBottomSheetFooterProps) {
  const {
    showClearFormButton,
    showCloseButton = true,
    openShiftsCount,
    openShiftsIsLoading,
    withShadow = true,
    onClear,
    onCancel,
    onSubmit,
  } = props;

  const openShiftsIsEmpty = openShiftsCount === 0 && !openShiftsIsLoading;

  const label = openShiftsIsEmpty ? "No shifts available" : `Show ${openShiftsCount} shifts`;

  return (
    <DialogFooter withShadow={withShadow} orientation="vertical" sx={{ gap: 7 }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
        {showCloseButton && (
          <IconButton size="large" variant="outlined" iconType="close" onClick={onCancel} />
        )}

        <Stack direction="row" alignItems="center" width="100%">
          {showClearFormButton && (
            <TextButton
              size="large"
              sx={{ marginLeft: 7, marginRight: "auto" }}
              aria-label="Reset filters"
              onClick={onClear}
            >
              Reset filters
            </TextButton>
          )}

          <LoadingButton
            aria-label={openShiftsIsLoading ? "Loading Open Shifts For Given Filters" : label}
            isLoading={openShiftsIsLoading}
            variant="contained"
            size="large"
            sx={{ marginLeft: showClearFormButton ? 0 : "auto" }}
            onClick={onSubmit}
          >
            {label}
          </LoadingButton>
        </Stack>
      </Stack>
    </DialogFooter>
  );
}
